import EmailEditor from './EmailEditor';

export default EmailEditor;
